const headingBaseStyles = {
  h1: {
    fontWeight: 700,
    fontSize: [`xl`, `2xl`, null, `3xl`, `4xl`],
    letterSpacing: `wide`,
    fontFamily: `heading`,
    lineHeight: `4xl`,
    marginTop: 0,
    marginBottom: 4,
  },
  h2: {
    fontWeight: 700,
    fontSize: [`lg`, `xl`, null, `2xl`, `3xl`],
    fontFamily: `heading`,
    lineHeight: `3xl`,
    marginBottom: 6,
  },
  h3: {
    fontWeight: 600,
    fontSize: [`md`, `lg`, null, `xl`, `2xl`],
    fontFamily: `heading`,
    lineHeight: `2xl`,
    marginTop: 6,
    marginBottom: 6,
  },
  h4: {
    fontWeight: 500,
    fontSize: [`md`, null, null, `lg`, `xl`],
    fontFamily: `heading`,
    lineHeight: `xl`,
    marginTop: 4,
    marginBottom: 4,
  },
}

export { headingBaseStyles }
